(function () {
    'use strict';

    /**
     *
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('pairingCompliments')
        .service('PairingComplimentsService', PairingComplimentsService);

    function PairingComplimentsService(PairingComplimentsFactory, RemoteService) {
        var self = this;


        self.searchPairingComplimentsMasterData = function( successFn, errorFn){
        	RemoteService.loadPairingComplimentsList().then(
                  function (response) {
                  	  var formatedList = PairingComplimentsFactory.formatPairingComplimentsList(response.pairingComplimentsListDTOs);
                      successFn(formatedList);
                  },
                  function (error) {
                      errorFn(error.msg[0]);
                  }
              );
        }



        self.searchPairingComplimentsGridData = function (masterCrewTypes,pairingComplimentsSearchReq, successFn, errorFn){
          var pairingComplimentsSearchReq = PairingComplimentsFactory.populatePairingComplimentsSearchRequest(pairingComplimentsSearchReq);
          RemoteService.searchPairingCompliments(pairingComplimentsSearchReq).then(
              function (response) {
            	  var pairingComplimentsInfo = PairingComplimentsFactory.formatPairingComplimentsInfoSearchResponse(masterCrewTypes, response.pairingComplimentsDTO);
                  successFn(pairingComplimentsInfo,response.startPosition);
              },
              function (error) {
                  errorFn(error.msg[0]);
              }
          );
       }


        self.searchLanugages = function(successFn, errorFn){
        	RemoteService.loadLanguageList().then(
                function (response) {
                  var langsList = PairingComplimentsFactory.formatLanguagesSearchResponse(response.languageList);
                  successFn(langsList);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
            );
        }

        self.getNewPairingCompliments = function(){
        	return PairingComplimentsFactory.getNewPairingCompliments();
        }


        self.formatGridSelectedRow = function(rowData,masterLists){
        	return PairingComplimentsFactory.formatGridSelectedRow(rowData, masterLists);
        }

        self.deletePairingComplimentsInfo = function(data,successFn, errorFn){
        	var pairingComplimentsDeleteRequest = PairingComplimentsFactory.populatePairingComplimentsDeleteRequest(data);
        	RemoteService.deletePairingComplimentsInfo(pairingComplimentsDeleteRequest).then(
                    function (response) {
                      successFn(response);
                    },
                    function (error) {
                      errorFn(error.msg[0]);
                    }
            );
        }

        self.savePairingCompliments = function(crewTypeCodes,SelectedData,successFn, errorFn){
        	var pairingComplimentsSaveRequest = PairingComplimentsFactory.populatePairingComplimentsSaveRequest(crewTypeCodes,SelectedData);
        	RemoteService.savePairingCompliments(pairingComplimentsSaveRequest).then(
                    function (response) {
                      successFn(response);
                    },
                    function (error) {
                      errorFn(error.msg[0]);
                    }
            );
        }

    }
})();
